export default class LmsIntegrationDomainService {
    static fromJSON(json) {
        return Object.assign({}, json);
    }
    static get blackboardBuildingBlock() {
        return {
            id: 1,
        };
    }
    static get blackboardRest() {
        return {
            id: 2,
        };
    }
    static get canvas() {
        return {
            id: 3,
        };
    }
    static get moodle() {
        return {
            id: 4,
        };
    }
    static get d2l() {
        return {
            id: 5,
        };
    }
    static get general() {
        return {
            id: 6,
        };
    }
}
